import type {
  ContributeFormState,
  ContributeSettingDraft,
  ContributeSourceDraft,
} from '@/lib/contribute-form';

export type ContributeSettingPayload = {
  name: string | null;
  keyId: string;
  structureLabel: string | null;
  abcNotation: string | null;
  primary: boolean;
};

export type ContributeSourcePayload = {
  kind: string;
  value: string;
  note: string | null;
};

export type ContributePiecePayload = {
  title: string;
  aka: string[];
  forms: string[];
  composerMode: string | null;
  composerName: string | null;
  composerYear: number | null;
  region: string | null;
  summary: string | null;
  settings: ContributeSettingPayload[];
  sources: ContributeSourcePayload[];
  creditMode: 'ATTRIBUTED' | 'ANONYMOUS';
};

function nullIfBlank(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length === 0 ? null : trimmed;
}

function mapSetting(setting: ContributeSettingDraft): ContributeSettingPayload {
  return {
    name: nullIfBlank(setting.name),
    keyId: setting.keyId as string,
    structureLabel: nullIfBlank(setting.structureLabel),
    abcNotation: nullIfBlank(setting.abcNotation),
    primary: setting.isPrimary,
  };
}

function mapSource(source: ContributeSourceDraft): ContributeSourcePayload {
  return {
    kind: source.kind.toUpperCase(),
    value: source.value.trim(),
    note: nullIfBlank(source.note),
  };
}

export function buildContributePayload(state: ContributeFormState): ContributePiecePayload {
  return {
    title: state.title.trim(),
    aka: state.aka.map((a) => a.trim()).filter((a) => a.length > 0),
    forms: state.forms,
    composerMode: state.composerMode === null ? null : state.composerMode.toUpperCase(),
    composerName: nullIfBlank(state.composerName),
    composerYear: state.composerYear.trim().length === 0 ? null : Number(state.composerYear),
    region: state.region === null ? null : state.region.toUpperCase(),
    summary: nullIfBlank(state.summary),
    settings: state.settings.map(mapSetting),
    sources: state.sources.map(mapSource),
    creditMode: state.composerMode === 'named' ? 'ATTRIBUTED' : 'ANONYMOUS',
  };
}
